import {
  CMETH_UETH_PAIR_ADDRESS,
  HWHLP_USDHL_PAIR_ADDRESS,
  HWHLP_USDT0_PAIR_ADDRESS,
  LHYPE_USDT0_PAIR_ADDRESS,
  MHYPE_WHYPE_PAIR_ADDRESS,
  USDXL_LHYPE_PAIR_ADDRESS
} from '../consts'
import { CheckedAddress } from '@/domain/types/CheckedAddress'

const loopPoints = {
  deposit: { multiplier: 1 },
  title: 'LOOP Points',
  eligibleFor: 'LOOP Points.',
  icon: 'loopPoints',
  tooltipBody:
    'earn LOOP Points. Users with LOOP points are eligible for Early Adopter Rewards (45% of token supply over 6 phases), LoopDrops (airdrops from underlying protocols) & LoyaltyDrops (buy-backs of LOOP, airdropped to holders).',
}

const wavePoints = {
  lend: { multiplier: 3 },
  borrow: { multiplier: 3 },
  deposit: { multiplier: 1 },
  title: 'Wave Points',
  eligibleFor: 'Wave Points',
  icon: 'waves',
  tooltipBody: "are eligible for Hyperwave's Wave Points.",
}

export const isolatedPartnerPoints = {
  [MHYPE_WHYPE_PAIR_ADDRESS]: {
    points: [
      {
        lend: { multiplier: 2 },
        borrow: { multiplier: 1 },
        deposit: { multiplier: 2 },
        title: 'Hyperpie Drops',
        eligibleFor: 'Hyperpie Drops.',
        icon: 'hyperpieDrops',
        tooltipBody:
          'are eligible for Hyperpie Drops. 30% of initial HPP supply will be airdropped to Hyperpie Drops holders.',
      },
    ],
  },
  [CMETH_UETH_PAIR_ADDRESS]: {
    points: [
      {
        deposit: { multiplier: 10 },
        title: 'Powder',
        eligibleFor: 'Powder.',
        icon: 'powder',
        tooltipBody: 'are eligible for Powder.',
      },
    ],
  },
  [USDXL_LHYPE_PAIR_ADDRESS]: {
    points: [loopPoints],
  },
  [LHYPE_USDT0_PAIR_ADDRESS]: {
    points: [loopPoints],
  },
  [HWHLP_USDT0_PAIR_ADDRESS]: {
    points: [wavePoints],
  },
  [HWHLP_USDHL_PAIR_ADDRESS]: {
    points: [wavePoints],
  },
}

export const incentivizedPairs = {}

export const POINTS_TOKEN_ADDRESS = CheckedAddress('0x707a696bbd913bcC979ad1d41a969Ab6ddEe6E27')
export const POINTS_CATCHALL_ADDRESS = CheckedAddress('0xA252e3495CdD94711A62e7a4ad27003C08AC00DB')
export const POINTS_LEADERBOARD_BLACKLIST = [POINTS_CATCHALL_ADDRESS]
export const POINTS_LEADERBOARD_ITEMS = 100

export const merklPoints = [
  {
    rewardTokenAddress: CheckedAddress('0x49c7B39A2E01869d39548F232F9B1586DA8Ef9c2'),
    week: 22,
  },
  {
    rewardTokenAddress: CheckedAddress('0x5eb02893A5A9A8259aA51AF5d1E794c189c69d7C'),
    week: 21,
    campaignId: '0x89bcf26e01760da7172a447b6578186934e5f6d5aa430ac3d3491dedf6e6f571',
  },
  {
    rewardTokenAddress: CheckedAddress('0xf6aCC05b4691dE9618A5b44c8e2051e895485619'),
    week: 20,
    campaignId: '0x928d7cc6c1d331f38e66aee19a5c3c65bf5e0c46ae17bfa5303d3eb28900a1c0',
  },
  {
    rewardTokenAddress: CheckedAddress('0x0A04dc9cBf6cf3BB216f24a501994eFfB2Aa8F6f'),
    week: 19,
    campaignId: '0x91350313ddea6b2f866a5d415e3957a919f3fb64b95c06fd52457765978c1ac2',
  },
]

export const currentWeekData = merklPoints[0]!
export const previousWeekData = merklPoints[1]!
export const finishedWeeks = merklPoints.slice(1)

export const currentWeek = currentWeekData.week
export const previousWeek = previousWeekData.week
